import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import {BACKEND_APIS} from "@constants";
import { CatalogueDetailsIsEmpty } from "../../@signals";


export default function useAnalyticsDetailsData() {
	const { showToast } = useAppToast()

	const data = useSignal([])

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			data.value = []
			postSubmit(`${BACKEND_APIS.ANALYTICS}/details/context`, { ...commonFiltersValue.value }).then(res => {
				if (!res?.length) CatalogueDetailsIsEmpty.value = true
				data.value = res
			}).catch(() => showToast.error()
			).finally(() => {
				isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value]);

	return {
		tableData: data.value
	}
}